module.exports = __webpack_public_path__ + "static/media/img-search@2x.b97bc0a4.png";